// eslint-disable-next-line spaced-comment
///  <reference types="vite/client" />
import '@tunasong/ui-lib/theme/tokens.css'
import '@tunasong/ui-lib/theme/print.css'
import '@tunasong/ui-lib/primitives/primitives.css'
import { openSidebarAgentWithFocus } from '@tunasong/plugin-agent/integration'
import { setBlockAffordanceCommandDeps } from '@tunasong/plugin-lib'
import { Provider, rootStore } from '@tunasong/redux'
import { DevBanner } from '@tunasong/tunasong-ui'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './app.js'
import { SEO } from './components/seo.js'

// Inject the production thunk so blockAffordance-derived palette commands
// can dispatch the sidebar-open action without plugin-lib taking a hard
// dependency on plugin-agent. One-time call at module-load. The slot in
// plugin-lib types `focus` as `unknown` to stay decoupled from plugin-agent;
// cast restores assignability for the stricter concrete thunk.
setBlockAffordanceCommandDeps({
  openSidebarAgentWithFocus: openSidebarAgentWithFocus as (args: {
    agentId: string
    focus: unknown
    draft?: string
  }) => unknown,
})

if (import.meta.env.DEV) {
  document.documentElement.dataset.dev = 'true'
}

// Scrollbar auto-hide (progressive enhancement; styled in primitives.css).
// Opt into the hidden-until-scrolling CSS, then flag the document as
// "scrolling" for a short window after each scroll so the themed thumb only
// appears while the user is actively scrolling. Capture phase catches scrolls
// from any element (scroll events don't bubble); passive for scroll perf.
document.documentElement.dataset.scrollbarAutohide = 'true'
let scrollIdleTimer: ReturnType<typeof setTimeout> | undefined
window.addEventListener(
  'scroll',
  () => {
    document.documentElement.dataset.scrolling = 'true'
    clearTimeout(scrollIdleTimer)
    scrollIdleTimer = setTimeout(() => {
      delete document.documentElement.dataset.scrolling
    }, 900)
  },
  { capture: true, passive: true }
)

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(document.getElementById('root')!)

root.render(
  <React.StrictMode>
    <SEO title="Tunasong" />
    <DevBanner />
    <Provider store={rootStore}>
      <App />
    </Provider>
  </React.StrictMode>
)
